import { Avatar, Stack } from '@mui/material';
import { getUrl } from 'aws-amplify/storage';
import { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../store';
import { updateImageCacheState } from '../../store/reducers/imageCacheSlice';

type IProfileProps = {
    profile_image: string;
    className?: any;
};
const OverlappingAvatar = styled(Avatar)(() => ({
    width: 30,
    height: 30,
    zIndex: 1,
}));
const ProfileView = ({ profile_image, className }: IProfileProps) => {
    const dispatch = useDispatch();
    const imageCacheData = useSelector((state: RootState) => state?.imageCache);
    const [imageUrl, setImageUrl] = useState<string>();
    const fetchImageUrl = useCallback(() => {
        return getUrl({
            path: profile_image,
            options: {
                expiresIn: 3600,
            },
        })
            .then(result => {
                if (!result || !result?.url) return null;
                return result?.url;
            })
            .catch(err => {
                console.error('Error fetching image:', err);
                return null;
            });
    }, [profile_image]);

    const isTimeBelowAnHour = (isoString: string) => {
        const date1 = new Date(isoString);
        const date2 = new Date();
        const diffInMs = date2.getTime() - date1.getTime();
        const diffInHours = diffInMs / (1000 * 60 * 60);
        return diffInHours <= 1;
    };

    const loadImage = useCallback(async () => {
        if (!profile_image) return;
        const imageId = profile_image.split('/')?.pop()?.split('.')?.[0] || '';
        const userImageData = imageCacheData?.[imageId];
        if (userImageData && userImageData?.imageUrl && isTimeBelowAnHour(userImageData?.timeStamp)) {
            setImageUrl(userImageData?.imageUrl?.toString());
        } else {
            const imageUrl = await fetchImageUrl();
            if (imageUrl && imageId) {
                setImageUrl(imageUrl?.toString());
                dispatch(
                    updateImageCacheState({
                        id: imageId,
                        imageData: {
                            imageUrl,
                            timeStamp: new Date()?.toISOString(),
                        },
                    }),
                );
            }
        }
    }, [profile_image, imageCacheData, dispatch, fetchImageUrl]);

    useEffect(() => {
        loadImage();
    }, [profile_image, loadImage]);
    return (
        <Stack className="userProfilePicBackground">
            <OverlappingAvatar src={imageUrl} className={className} />
        </Stack>
    );
};
export default memo(ProfileView);
